const fakedata = [
    {
        Name: "John Doe",
        id: 1,
        description: "I run a small freelancing business in the heart of Lagos. My former laptop finally packed up after several attempts at refurbishing it, I would like a loan to get a new laptop to continue my business. My business loremipsum.com generates enough money to repay the loan in three months. I would really appreciate funding for this campaign. Thank you for your time 🙂...........",
        campaigns: 1,
        location: "Lagos, Nigeria",
        date: "12/12/2020",
        raised: 65200,
        total: 250000,
        rank:"popular"
    },
    {
        Name: "John Doe2",
        id: 1,
        description: "I run a small freelancing business in the heart of Lagos. My former laptop finally packed up after several attempts at refurbishing it, I would like a loan to get a new laptop to continue my business. My business loremipsum.com generates enough money to repay the loan in three months. I would really appreciate funding for this campaign. Thank you for your time 🙂...........",
        campaigns: 2,
        location: "Abuja, Nigeria",
        date: "12/10/2020",
        raised: 6500,
        total: 25000,
        rank:"old"
    },
    {
        Name: "John Doe3",
        id: 1,
        description: "I run a small freelancing business in the heart of Lagos. My former laptop finally packed up after several attempts at refurbishing it, I would like a loan to get a new laptop to continue my business. My business loremipsum.com generates enough money to repay the loan in three months. I would really appreciate funding for this campaign. Thank you for your time 🙂...........",
        campaigns: 3,
        location: "Abuja, Nigeria",
        date: "12/10/2020",
        raised: 6500,
        total: 25000,
        rank:"old"
    },
    {
        Name: "John Doe4",
        id: 1,
        description: "I run a small freelancing business in the heart of Lagos. My former laptop finally packed up after several attempts at refurbishing it, I would like a loan to get a new laptop to continue my business. My business loremipsum.com generates enough money to repay the loan in three months. I would really appreciate funding for this campaign. Thank you for your time 🙂...........",
        campaigns: 4,
        location: "Abuja, Nigeria",
        date: "12/10/2020",
        raised: 6500,
        total: 25000,
        rank:"old"
    },
    {
        Name: "John Doe5",
        id: 1,
        description: "I run a small freelancing business in the heart of Lagos. My former laptop finally packed up after several attempts at refurbishing it, I would like a loan to get a new laptop to continue my business. My business loremipsum.com generates enough money to repay the loan in three months. I would really appreciate funding for this campaign. Thank you for your time 🙂...........",
        campaigns: 5,
        location: "Abuja, Nigeria",
        date: "12/10/2020",
        raised: 6500,
        total: 25000,
        rank:"old"
    },
    {
        Name: "John Doe6",
        id: 1,
        description: "I run a small freelancing business in the heart of Lagos. My former laptop finally packed up after several attempts at refurbishing it, I would like a loan to get a new laptop to continue my business. My business loremipsum.com generates enough money to repay the loan in three months. I would really appreciate funding for this campaign. Thank you for your time 🙂...........",
        campaigns: 6,
        location: "Abuja, Nigeria",
        date: "12/10/2020",
        raised: 6500,
        total: 25000,
        rank:"old"
    }
]


export default fakedata
